export default {"name":"NovaComponents-Tokenizer-gui-icu","comments":[],"messages":{"NovaComponents-Tokenizer-gui-icu.tokenizer.default.aria":"Tokens"}}